export default {
  en: {
    List: {
      firstMessage: 'Enter the title in the form below and click the Create button.',
      title: 'Positioning map',
      input: 'Please enter a title',
      createButton: 'Create'
    },
    Workspace: {
      firstMessage: 'It can be anywhere on the screen, so click on it. After that, feel free to enjoy creating the positioning map.',
      object: {
        deleteButton: 'Delete Object',
        showInCircle: 'Show in circle',
        showAlongCircle: 'Show along circle'
      },
      setting: {
        deleteButton: 'Delete map',
        message: 'Are you sure you want to delete the positioning map?',
        yesButton: 'Yes',
        noButton: 'No'
      }
    }
  }
}
